import styled, { css } from 'styled-components';
import { BasePaginatorHeader, BasePaginatorListItem, DownArrowSquareIcon } from 'styles/components';
import { Colors, ColorScheme } from 'styles/constants';
export {
  PaginatorColumn as Column,
  PaginatorActionsColumn as ActionsColumn,
  ActionButton,
  LinkActionButton,
  EditIcon,
} from 'styles/components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const baseGridCss = css`
  grid-template-columns: 60px 350px 140px auto min-content
`;

export const ListHeader = styled(BasePaginatorHeader)`
  ${baseGridCss}
`;

export const ListItem = styled(BasePaginatorListItem)`
  ${baseGridCss}
`;

export const DownloadIcon = styled(DownArrowSquareIcon)`
  transition: all 200ms;
  color: ${ColorScheme.Text};

  &:hover {
    transform: scale(1.1);
  }
`

export const DownloadButton = styled.button`
  padding-top: 4px;
  &:disabled {
    ${DownloadIcon} {
      color: ${Colors.Gray40};
    }
  }
`
